import type { ReactNode } from 'react';
import styles from './ConfirmModal.module.css';

interface ConfirmModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title?: ReactNode;
  message?: ReactNode;
  buttonText?: string;
}

export default function ConfirmModal({ isOpen, onClose, onConfirm, title, message, buttonText }: ConfirmModalProps) {
  if (!isOpen) return null;

  return (
    <div className={styles.modalOverlay}>
      <div className={styles.modal}>
        <h2>{title}</h2>
        <p>{message}</p>
        <div className={styles.buttons}>
          <button onClick={onClose}>Abbrechen</button>
          <button onClick={onConfirm}>{buttonText || "Eintragen"}</button>
        </div>
      </div>
    </div>
  );
}
